import { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'

import { selectUserBuildingName, selectUserRole } from '../../reducers/userDataReducer'
import { selectClients } from '../../reducers/clientsReducer'
import { selectActiveBuilding } from '../../reducers/buildingSelectorReducer'
import Dashboard from '../Dashboard'

import ReservationsToolbar from './ReservationsToolbar/ReservationsToolbar'
import ReservationForClientForm from './ReservationForClientForm/ReservationForClientForm'
import ReservationsAddTimeBlockModal from './ReservationsAddTimeBlockModal/ReservationsAddTimeBlockModal'
import AmenityMarketplaceModal from './AmenityMarketplaceModal/AmenityMarketplaceModal'

const STRIPE_OPTIONS = {
  fonts: [
    {
      cssSrc: 'https://fonts.googleapis.com/css?family=Montserrat:400,500,700&amp;subset=latin-ext',
    },
  ],
}

const Reservations = (props) => {
  const [newReservationFormVisible, setNewReservationFormVisible] = useState(false)
  const [isAnalyticsVisible, setIsAnalyticsVisible] = useState(true)
  const [addTimeBlockModalVisible, setAddTimeBlockModalVisible] = useState(false)
  const [amenityMarketplaceModalVisible, setAmenityMarketplaceModalVisible] = useState(false)

  const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY)

  return (
    <Elements stripe={stripePromise} options={STRIPE_OPTIONS}>
      <Dashboard.Container
        className={`ctp-reservations ${!isAnalyticsVisible && 'analytics-hidden'}`}
      >
        <ReservationsToolbar
          isAnalyticsVisible={isAnalyticsVisible}
          setNewReservationFormVisible={() => setNewReservationFormVisible(true)}
          toggleAnalyticsVisibility={() =>
            setIsAnalyticsVisible((isAnalyticsVisible) => !isAnalyticsVisible)
          }
          setAddTimeBlockModalVisible={() => setAddTimeBlockModalVisible(true)}
          setAmenityMarketplaceModalVisible={() => setAmenityMarketplaceModalVisible(true)}
          {...props}
        />
        <div className="ctp-reservations__inner">
          <Outlet />
        </div>
        {newReservationFormVisible && (
          <ReservationForClientForm
            handleCancel={() => setNewReservationFormVisible(false)}
            residents={props.users}
            buildingData={props.selectedBuilding}
          />
        )}
        {addTimeBlockModalVisible && (
          <ReservationsAddTimeBlockModal
            onClose={() => setAddTimeBlockModalVisible(false)}
            buildingData={props.selectedBuilding}
          />
        )}
        {amenityMarketplaceModalVisible && (
          <AmenityMarketplaceModal
            onClose={() => setAmenityMarketplaceModalVisible(false)}
            buildingData={props.selectedBuilding}
          />
        )}
      </Dashboard.Container>
    </Elements>
  )
}

Reservations.propTypes = {
  children: PropTypes.element,
  userBuilding: PropTypes.string,
  userRole: PropTypes.string,
  users: PropTypes.array,
  selectedBuilding: PropTypes.object,
}

const mapClientToUser = ({ id, apartment: unit, user, phone, creditCardId }) => ({
  value: id,
  userId: user.id,
  label: `${user.firstName} ${user.lastName}`,
  email: user.email,
  phone,
  unit,
  creditCardId,
})

export default connect((state) => ({
  selectedBuilding: selectActiveBuilding(state),
  userBuilding: selectUserBuildingName(state),
  userRole: selectUserRole(state),
  users: selectClients(state).map(mapClientToUser),
}))(Reservations)
